import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { CreateExportInput, ExportDto } from '@cutlyft/zod-schemas';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';

interface CreateExportApiResponse {
  success: boolean;
  data: { export: ExportDto; downloadUrl: string };
}

export function useCreateExport() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (input: CreateExportInput) => {
      const response = await apiClient.post<CreateExportApiResponse>('/exports', input);
      return response.data.data;
    },
    onSuccess: () => {
      // Prefix-invalidate so all list queries (any filter combination) refetch.
      queryClient.invalidateQueries({ queryKey: ['exports', 'list'] });
    },
  });
}
